/* ef-orderform-simple.js (2026-05-08)
 * Quick Ship variant of the orderform — for products with cfg-simple data
 * schema (simple_width / simple_height / simple_models). Two size dropdowns
 * (width range + height range) → resolves to a model + overall dimensions.
 * Same look-and-feel as ef-orderform-doors.js but ~10x smaller.
 */
(function () {
  'use strict';

  var root = document.getElementById('efOf');
  if (!root) return;

  var BASE_VARIANT_ID = root.dataset.variantId || '';
  var BASE_PRICE = parseInt(root.dataset.basePrice || '0', 10);
  var PRODUCT_HANDLE = root.dataset.productHandle || '';
  var PRODUCT_TITLE = root.dataset.productTitle || '';
  var CFG_GROUP = root.dataset.cfgGroup || '';

  var widthSel = document.getElementById('efOfSimpleWidth');
  var heightSel = document.getElementById('efOfSimpleHeight');
  var overallBox = document.getElementById('efOfSimpleOverall');
  var overallModel = document.getElementById('efOfSimpleModel');
  var overallDims = document.getElementById('efOfSimpleDims');
  var msgEl = document.getElementById('efOfMsg');
  var atcBtn = document.getElementById('efOfAtc');
  var atcLabel = atcBtn && atcBtn.querySelector('.ef-of__atc-label');
  var totalAmt = document.getElementById('efOfTotalAmt');
  var baseAmt = document.getElementById('efOfBaseAmt');
  var notesEl = document.getElementById('efOfNotes');
  var fileInput = document.getElementById('efOfFile');
  var fileLabel = document.getElementById('efOfFileLabel');
  var expressBtn = document.getElementById('efOfExpressCheckout');

  function money(cents) {
    var n = Math.round(cents);
    if (n % 100 === 0) return '$' + (n / 100).toLocaleString('en-US');
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }
  function moneyDollars(d) { return money(d * 100); }

  function msg(text, kind) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'ef-of__msg ef-of__msg--' + (kind || 'ok');
    msgEl.hidden = false;
  }

  /* ── Find the data block — same fuzzy match as orderform-doors. ── */
  function findGroupData() {
    var data = window.EF_CFG_DATA || {};
    var keys = Object.keys(data);
    if (!keys.length) return null;
    if (CFG_GROUP && data[CFG_GROUP]) return data[CFG_GROUP];
    /* Match by slug-last-word in display key (e.g. "doors-ardmore-armitage" → key contains "ardmore") */
    if (CFG_GROUP) {
      var parts = CFG_GROUP.split('-').slice(1).filter(function (p) { return p.length >= 4; });
      for (var i = 0; i < keys.length; i++) {
        var lc = keys[i].toLowerCase();
        for (var j = 0; j < parts.length; j++) {
          if (lc.indexOf(parts[j]) !== -1) return data[keys[i]];
        }
      }
    }
    return data[keys[0]];
  }

  function whenDataReady(cb) {
    var start = Date.now();
    function poll() {
      var d = window.EF_CFG_DATA;
      if (d && Object.keys(d).length) return cb(true);
      if (Date.now() - start > 8000) return cb(false);
      setTimeout(poll, 120);
    }
    poll();
  }

  /* ── State ── */
  var state = { width: null, height: null, model: null };
  var groupData = null;

  /* simple_height is a 2D array indexed by width selection
     (e.g. width[0] → heights[0], width[1] → heights[1]). simple_models
     follows the same shape, indexed [widthIdx][heightIdx]. So height
     options must REPOPULATE every time width changes. */
  function populateDropdowns() {
    groupData = findGroupData();
    if (!groupData) {
      msg('Configurator data did not load. Please refresh or call (949) 619-7824.', 'err');
      return;
    }
    var widths = groupData.simple_width || [];
    if (!widths.length) {
      msg('No size options available. Call (949) 619-7824 to order.', 'err');
      return;
    }

    widths.forEach(function (w, idx) {
      var o = document.createElement('option');
      o.value = w.label;
      var p = w.price || 0;
      o.textContent = w.label + (p > 0 ? ' (+' + moneyDollars(p) + ')' : '');
      o.dataset.idx = idx;
      o.dataset.price = p;
      o.dataset.variantId = w.variantId || '';
      widthSel.appendChild(o);
    });

    if (widths.length === 1) {
      widthSel.value = widths[0].label;
      populateHeights(0);
    }
  }

  function populateHeights(widthIdx) {
    /* Clear existing options except placeholder */
    while (heightSel.options.length > 1) heightSel.remove(1);

    var heightArr = groupData.simple_height && groupData.simple_height[widthIdx];
    if (!Array.isArray(heightArr) || !heightArr.length) {
      heightSel.disabled = true;
      return;
    }
    heightSel.disabled = false;
    heightArr.forEach(function (h, idx) {
      var o = document.createElement('option');
      o.value = h.label;
      var p = h.price || 0;
      o.textContent = h.label + (p > 0 ? ' (+' + moneyDollars(p) + ')' : '');
      o.dataset.idx = idx;
      o.dataset.price = p;
      o.dataset.variantId = h.variantId || '';
      heightSel.appendChild(o);
    });
    /* Auto-select if only one height option */
    if (heightArr.length === 1) heightSel.value = heightArr[0].label;
    onSizeChange();
  }

  function onWidthChange() {
    var wOpt = widthSel.options[widthSel.selectedIndex];
    var widthIdx = wOpt && wOpt.dataset.idx ? parseInt(wOpt.dataset.idx, 10) : -1;
    if (widthIdx < 0) {
      heightSel.innerHTML = '<option value="">Select width first…</option>';
      heightSel.disabled = true;
      state.width = null;
      onSizeChange();
      return;
    }
    state.width = widthSel.value;
    populateHeights(widthIdx);
  }

  function onSizeChange() {
    state.width = widthSel.value || null;
    state.height = heightSel.value || null;

    if (state.width && state.height) {
      /* simple_models is 2D — [widthIdx][heightIdx]. */
      var wOpt = widthSel.options[widthSel.selectedIndex];
      var hOpt = heightSel.options[heightSel.selectedIndex];
      var widthIdx  = wOpt && wOpt.dataset.idx ? parseInt(wOpt.dataset.idx, 10) : 0;
      var heightIdx = hOpt && hOpt.dataset.idx ? parseInt(hOpt.dataset.idx, 10) : 0;
      var modelArr = groupData.simple_models && groupData.simple_models[widthIdx];
      var match = (Array.isArray(modelArr) && modelArr[heightIdx]) || null;
      state.model = match;

      if (overallBox) overallBox.hidden = false;
      if (overallModel) overallModel.textContent = (match && (match.name || match.label)) || 'Standard Model';
      if (overallDims) {
        overallDims.textContent = (match && match.overall) ? match.overall : (state.width + ' wide × ' + state.height + ' tall');
      }
    } else {
      if (overallBox) overallBox.hidden = true;
    }
    recomputeTotal();
  }

  /* Compute the size tier label (S / L / XL) from width+height indices.
     Only 3 valid combos exist in cfg-simple data:
       - width[0] + height[0] → Standard (S, base price)
       - width[0] + height[1] → L (taller)
       - width[1] + height[0] → XL (wider, only one height option) */
  function tierFor(widthIdx, heightIdx) {
    if (widthIdx === 1) return 'XL';
    if (widthIdx === 0 && heightIdx === 1) return 'L';
    return 'S';
  }

  function recomputeTotal() {
    var wOpt = widthSel.options[widthSel.selectedIndex];
    var hOpt = heightSel.options[heightSel.selectedIndex];
    var widthSur  = wOpt && parseInt(wOpt.dataset.price || '0', 10) || 0;
    var heightSur = hOpt && parseInt(hOpt.dataset.price || '0', 10) || 0;
    var widthIdx  = wOpt && wOpt.dataset.idx ? parseInt(wOpt.dataset.idx, 10) : -1;
    var heightIdx = hOpt && hOpt.dataset.idx ? parseInt(hOpt.dataset.idx, 10) : -1;

    /* Surcharge prices in EF_CFG_DATA are DOLLARS (per project memory). */
    var totalDollars = (BASE_PRICE / 100) + widthSur + heightSur;
    var totalCents = Math.round(totalDollars * 100);

    if (baseAmt) baseAmt.textContent = money(BASE_PRICE);
    if (totalAmt) totalAmt.textContent = money(totalCents);
    var atcPrice = document.getElementById('efOfAtcPrice');
    if (atcPrice) atcPrice.textContent = money(totalCents);

    /* Render single combined "+ Size L (+$74)" or "+ Size XL (+$124)" row
       between Base and Total when upgrade selected. Replaces the previous
       two separate "Simple Width" / "Simple Height" lines per user request. */
    var totalEl = document.getElementById('efOfTotal');
    var sizeRow = document.getElementById('efOfSimpleSizeRow');
    var sizeUpDollars = widthSur + heightSur;
    var tier = tierFor(widthIdx, heightIdx);
    state.tier = tier;

    if (totalEl && sizeUpDollars > 0 && tier !== 'S') {
      if (!sizeRow) {
        sizeRow = document.createElement('div');
        sizeRow.id = 'efOfSimpleSizeRow';
        sizeRow.className = 'ef-of__total-row';
        var baseRow = totalEl.querySelector('.ef-of__total-row');
        if (baseRow && baseRow.nextSibling) {
          totalEl.insertBefore(sizeRow, baseRow.nextSibling);
        } else {
          totalEl.appendChild(sizeRow);
        }
      }
      sizeRow.innerHTML = '<span class="ef-of__total-lbl">+ Size ' + tier + '</span>'
        + '<span class="ef-of__total-amt">+' + moneyDollars(sizeUpDollars) + '</span>';
    } else if (sizeRow) {
      sizeRow.remove();
    }
  }

  /* ── Drop-zone for photo upload — same pattern as orderform-doors. ── */
  if (fileInput && fileLabel) {
    var fileDrop = document.getElementById('efOfFileDrop');
    var fileIcon = fileDrop && fileDrop.querySelector('.ef-of__upload-icon');
    var fileHint = fileDrop && fileDrop.querySelector('.ef-of__upload-hint');
    var preview = null;

    function showPreview(dataUrl, name) {
      if (!fileDrop) return;
      if (!preview) {
        preview = document.createElement('div');
        preview.className = 'ef-of__upload-preview';
        preview.innerHTML = '<img class="ef-of__upload-preview__img" alt="">'
          + '<button type="button" class="ef-of__upload-preview__remove" aria-label="Remove">'
          + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg></button>';
        fileDrop.insertBefore(preview, fileIcon);
        preview.querySelector('button').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          fileInput.value = '';
          fileInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      preview.querySelector('img').src = dataUrl;
      preview.style.display = '';
      if (fileIcon) fileIcon.style.display = 'none';
      if (fileHint) fileHint.textContent = 'Click to replace · ' + (name || '');
      fileDrop.classList.add('has-file');
    }
    function hidePreview() {
      if (preview) preview.style.display = 'none';
      if (fileIcon) fileIcon.style.display = '';
      if (fileHint) fileHint.textContent = 'JPG, PNG up to 10MB';
      fileDrop.classList.remove('has-file');
    }
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) {
        fileLabel.textContent = f.name;
        var r = new FileReader();
        r.onload = function (e) { showPreview(e.target.result, f.name); };
        r.readAsDataURL(f);
      } else {
        fileLabel.textContent = 'Drag a photo here or click to browse';
        hidePreview();
      }
    });
    if (fileDrop) {
      ['dragenter','dragover'].forEach(function (e) {
        fileDrop.addEventListener(e, function (ev) { ev.preventDefault(); ev.stopPropagation(); fileDrop.classList.add('is-dragover'); });
      });
      ['dragleave','drop'].forEach(function (e) {
        fileDrop.addEventListener(e, function (ev) { ev.preventDefault(); ev.stopPropagation(); fileDrop.classList.remove('is-dragover'); });
      });
      fileDrop.addEventListener('drop', function (e) {
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(files[0]);
          fileInput.files = dt.files;
        } catch (err) {}
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  /* ── ATC ── */
  function buildCartItems() {
    var configId = 'cfg-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    /* No _parent_product on main — orphan cleanup classifies items WITHOUT
       _parent_product as main; with would mark all as orphans. */
    var properties = { _config_id: configId };
    if (state.width)  properties['Opening Width']  = state.width;
    if (state.height) properties['Opening Height'] = state.height;
    if (state.tier && state.tier !== 'S') properties['Size'] = state.tier;
    if (state.model && (state.model.name || state.model.label)) {
      properties['Model'] = state.model.name || state.model.label;
    }
    if (notesEl && notesEl.value) properties['Notes'] = notesEl.value;

    var mainId = parseInt(BASE_VARIANT_ID, 10);
    if (!mainId || isNaN(mainId)) {
      console.error('[ef-orderform-simple] Missing BASE_VARIANT_ID');
      return [];
    }
    var items = [{ id: mainId, quantity: 1, properties: properties }];

    /* Width / height surcharges as separate line items (each has its own
       hidden Shopify variant) but TAGGED with the unified Size tier name
       so the cart drawer can group them under "Size L" / "Size XL" rather
       than "Simple Width" / "Simple Height". */
    var sizeLabel = state.tier && state.tier !== 'S' ? ('Size ' + state.tier) : null;
    [widthSel, heightSel].forEach(function (sel) {
      var opt = sel && sel.options[sel.selectedIndex];
      if (!opt) return;
      var vid = parseInt(opt.dataset.variantId || '', 10);
      var price = parseInt(opt.dataset.price || '0', 10);
      if (!vid || isNaN(vid) || price <= 0) return;
      items.push({
        id: vid, quantity: 1,
        properties: {
          _parent_product: PRODUCT_TITLE,
          _option_type: sizeLabel || 'Size',
          _config_id: configId
        }
      });
    });
    return items;
  }

  function validate() {
    if (!state.width || !state.height) {
      msg('Please select width AND height.', 'err');
      try { (state.width ? heightSel : widthSel).focus(); } catch (e) {}
      return false;
    }
    return true;
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (atcBtn.disabled) return;
      if (!validate()) return;
      var origLabel = atcLabel ? atcLabel.textContent : 'Add to Cart';
      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Adding…';
      var items = buildCartItems();
      console.group('[ef-orderform-simple] ATC payload');
      items.forEach(function (it, i) { console.log('  [' + i + ']', it); });
      console.groupEnd();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || ('Cart ' + r.status));
          return j;
        });
      })
      .then(function () {
        if (atcLabel) atcLabel.textContent = 'Added ✓';
        atcBtn.style.background = '#1F7A3A';
        msg('Added to cart!', 'ok');
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
        setTimeout(function () {
          if (window.EFCartDrawer && window.EFCartDrawer.open) window.EFCartDrawer.open();
          else window.location.href = '/cart';
          setTimeout(function () {
            atcBtn.disabled = false;
            atcBtn.style.background = '';
            if (atcLabel) atcLabel.textContent = origLabel;
          }, 1200);
        }, 700);
      })
      .catch(function (err) {
        console.error('[ef-orderform-simple] ATC failed:', err);
        msg('Could not add: ' + err.message + '. Try again or call (949) 619-7824.', 'err');
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = origLabel;
      });
    });
  }

  if (expressBtn) {
    expressBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!validate()) return;
      expressBtn.disabled = true;
      var origText = (expressBtn.querySelector('span') || {}).textContent || 'Express Checkout';
      var span = expressBtn.querySelector('span');
      if (span) span.textContent = 'Starting checkout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: buildCartItems() })
      })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        expressBtn.disabled = false;
        if (span) span.textContent = origText;
        msg('Express Checkout failed. Try regular Add to Cart.', 'err');
      });
    });
  }

  /* ── Boot ── */
  if (widthSel)  widthSel.addEventListener('change', onWidthChange);
  if (heightSel) heightSel.addEventListener('change', onSizeChange);
  whenDataReady(function (loaded) {
    if (!loaded) {
      msg('Configurator data did not load. Refresh or call (949) 619-7824.', 'err');
      return;
    }
    populateDropdowns();
  });
})();
